/**
 * PedSeguro Front End App
 * https://pedseguro.com.br
 *
 * @format
 * @flow strict-local
 */

import React from 'react';
import { createAppContainer } from "react-navigation";
import { createStackNavigator } from "react-navigation-stack";
import { NavigationContainer } from '@react-navigation/native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { TouchableOpacity, Text, StyleSheet, DeviceEventEmitter } from 'react-native';

import HomeScreen from "./src/screens/HomeScreen";
import CategoriesScreen from "./src/screens/CategoriesScreen";
import ProductsScreen from "./src/screens/ProductsScreen";
import CheckoutScreen from "./src/screens/CheckoutScreen";
import OrdersScreen from "./src/screens/OrdersScreen";
import OrderDetailsScreen from "./src/screens/OrderDetailsScreen";
import BalanceScreen from "./src/screens/BalanceScreen";
import CashBalanceScreen from './src/screens/CashBalanceScreen';
import BalanceEntriesScreen from './src/screens/BalanceEntriesScreen';
import { CartProvider } from "./src/context/CartContext";
import { CategoriesProvider } from "./src/context/CategoriesContext";
import { ProductsProvider } from "./src/context/ProductsContext";
import { GlobalProvider } from "./src/context/GlobalContext";
import { PaymentMethodsProvider } from './src/context/PaymentMethodsContext';

/*
const navigator = createStackNavigator(
  {
    Loader: LoaderScreen,
    Home: HomeScreen,
    Categories: CategoriesScreen,
    Products: ProductsScreen,
    Checkout: CheckoutScreen,
    Orders: OrdersScreen,
    OrderDetails: OrderDetailsScreen
  },
  {
    initialRouteName: "Home",
    defaultNavigationOptions: {
      title: "Prático | Rápido | Seguro",
      
      //headerTitleStyle: {
      //  alignSelf: 'center' 
      //},
      
      //headerLeft: () => (
      //  <TouchableOpacity style={styles.buttons} onPress={() => { DeviceEventEmitter.emit('goback', {}); }}>
      //    <Text style={styles.buttonText}>Voltar</Text>
      //  </TouchableOpacity>
      //)
    }
  }
);

const styles = StyleSheet.create({
  buttons: {
    backgroundColor: '#F0A22E',
    borderRadius: 10,
    paddingHorizontal: 30,
    paddingVertical: 8,
    marginLeft: 10
  },
  buttonText: {
    fontSize: 20,
    color: 'black'
  }
});
*/

const version = '2.0.0.3';
const Stack = createNativeStackNavigator();

const App = () => {
  return (
    <GlobalProvider>
      <CategoriesProvider>
        <CartProvider>
          <ProductsProvider>
            <PaymentMethodsProvider>
              <NavigationContainer>
                <Stack.Navigator
                  screenOptions={{
                    title: 'PedSeguro - Rápido | Prático | Seguro',
                    headerTintColor: 'white',
                    headerStyle: { backgroundColor: '#965e11' },
                    headerTitleStyle: { fontSize: 16 },
                    headerRight: () => (
                      <TouchableOpacity onPress={() => alert('PedSeguro\nVersão ' + version)}>
                        <Text style={{marginRight: 10, fontSize: 10, color: 'white'}}>Sobre</Text>
                      </TouchableOpacity>
                    )
                  }}>
                  <Stack.Screen name="Home" component={HomeScreen}/>
                  <Stack.Screen name="Categories" component={CategoriesScreen} />
                  <Stack.Screen name="Products" component={ProductsScreen} />
                  <Stack.Screen name="Checkout" component={CheckoutScreen} />
                  <Stack.Screen name="Orders" component={OrdersScreen} />
                  <Stack.Screen name="OrderDetails" component={OrderDetailsScreen} />
                  <Stack.Screen name="Balance" component={BalanceScreen} />
                  <Stack.Screen name="CashBalance" component={CashBalanceScreen} />
                  <Stack.Screen name="BalanceEntries" component={BalanceEntriesScreen} />
                </Stack.Navigator>
              </NavigationContainer>
            </PaymentMethodsProvider>
          </ProductsProvider>
        </CartProvider>
      </CategoriesProvider>
    </GlobalProvider>
  );
}

export default App;

/*
const App = createAppContainer(navigator);

export default () => { return (
  <PaymentMethodsProvider>
    <CategoriesProvider>
      <ProductsProvider>
        <PrinterProvider>
          <CartProvider>
            <App />
          </CartProvider>
        </PrinterProvider>
      </ProductsProvider>
    </CategoriesProvider>
  </PaymentMethodsProvider>
)};
*/